// Password policy (solo frontend: il backend non valida la robustezza, per scelta).
// Requisiti standard uguali su tutti i software EffAI.

export interface PasswordRequirement {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: "length",
    label: "Almeno 10 caratteri",
    test: (p) => p.length >= 10,
  },
  {
    id: "uppercase",
    label: "Almeno una lettera maiuscola",
    test: (p) => /[A-Z]/.test(p),
  },
  {
    id: "lowercase",
    label: "Almeno una lettera minuscola",
    test: (p) => /[a-z]/.test(p),
  },
  {
    id: "number",
    label: "Almeno un numero",
    test: (p) => /[0-9]/.test(p),
  },
  {
    id: "special",
    label: "Almeno un carattere speciale",
    test: (p) => /[^A-Za-z0-9\s]/.test(p),
  },
];

export function validatePassword(password: string): {
  valid: boolean;
  missing: PasswordRequirement[];
} {
  const missing = PASSWORD_REQUIREMENTS.filter((r) => !r.test(password));
  return { valid: missing.length === 0, missing };
}

/** Stringa pronta per un toast di errore con i requisiti mancanti ("" se la password è valida). */
export function describeMissingRequirements(password: string): string {
  const { valid, missing } = validatePassword(password);
  if (valid) return "";
  const items = missing.map((r) => r.label.charAt(0).toLowerCase() + r.label.slice(1));
  return `La password non rispetta i requisiti: ${items.join(", ")}.`;
}
